
import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const Customer = lazy(() => import("@/pages/MyCustomer/MyCustomer/Customer"));
const MyCustomer = lazy(() => import("@/pages/MyCustomer/MyCustomer/MyCustomer"));
const MyCustRequest = lazy(() => import("@/pages/MyCustomer/MyCustRequest/MyCustRequest"));
const CustomerList = lazy(() => import("@/pages/MyCustomer/MyCustomer/CustomerList"));
const BulkUpload = lazy(() => import("@/pages/MyCustomer/MyCustomer/BulkUpload/BulkUpload"));
const BulkReport = lazy(() => import("@/pages/MyCustomer/MyCustomer/BulkReport/BulkReport"));
const BulkReportView = lazy(() => import("@/pages/MyCustomer/MyCustomer/BulkReport/BulkReportView"));
const CustomerRequest = lazy(() => import("@/pages/MyCustomer/CustomerRequest/CustomerRequest"));

const MyCustomerRoutes: RouteConfig = {
  path: "",
  element: <MyCustomer />,
  pageName: "My Customers",
  sidebar: {
    show: true,
    icon: "/assets/media/customerLogo.svg"
  },
  permission: ["CustomersView", "ViewAllCustomers"],
  children: {
    CUSTOMER: {
      path: "customers",
      element: <Customer />,
      pageName: "My Customer",
      sidebar: { show: true, icon: "" },
      children: {
        MAIN: {
          path: "",
          element: <CustomerList />,
          pageName: "My Customer",
          sidebar: { show: false },
        },

        CustomerBulkUpload: {
          path: "BulkUploadCustomer",
          element: <BulkUpload heading="Customer Bulk Upload" type="Lead" />,
          pageName: "My Customer",
          sidebar: { show: false }
        },
        BulkUploadLogs: {
          path: "BulkUploadLogs",
          element: <BulkUpload heading="Customer Logs Bulk Upload" type="CRMLeadTransaction" />,
          pageName: "My Customer",
          sidebar: { show: false }
        },

        BulkReportCustomer: {
          path: "BulkReportCustomer",
          element: <BulkReport type="Lead" heading="Customer Bulk Report" />,
          pageName: "My Customer",
          sidebar: { show: false },
        },
        BulkReportLogs: {
          path: "BulkReportLogs",
          element: <BulkReport type="CRMLeadTransaction" heading="Customer Logs Bulk Report" />,
          pageName: "My Customer",
          sidebar: { show: false },
        },

        BulkReportCustomerView: {
          path: "BulkReportCustomer/view-report/:id",
          element: <BulkReportView type="Lead" />,
          pageName: "My Customer",
          sidebar: { show: false }
        },
        BulkReportTransactionView: {
          path: "BulkReportLogs/view-report/:id",
          element: <BulkReportView type="CRMLeadTransaction" />,
          pageName: "My Customer",
          sidebar: { show: false }
        },
      }
    },
    CustomerRequest: {
      path: "customer-request",
      element: <CustomerRequest />,
      pageName: "Customer Request",
      sidebar: { show: true, icon: "" },
      permission: ["LeadApproval"],
    },
    MyCustomerRequest: {
      path: "request",
      element: <MyCustRequest />,
      pageName: "Distributor Request",
      sidebar: { show: true, icon: "" },
    }
  }
}
export default MyCustomerRoutes;